<template>
    <div class="module-manage">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>市场专题</el-breadcrumb-item>
            <el-breadcrumb-item>模块管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="special-head">
            <div slot="header">
                <p class="title">市场专题列表</p>
            </div>
            <div class="special-select">
                <span>专题选择</span>
                <el-select v-model="specialId" @change="selectSpecial" placeholder="请选择">
                    <el-option v-for="item in specialList" :key="item.specialId" :label="item.specialName" :value="item.specialId">
                    </el-option>
                </el-select>
            </div>
        </el-card>
        <el-card class="add-module" v-if="specialId">
            <div slot="header">
                <p class="title">添加模块</p>
            </div>
            <div class="module-add-box">
                <el-form :model="addModuleForm" :rules="validateRules" ref="addModuleForm" label-width="100px" class="addSpecialForm">
                    <el-form-item label="模块名称" prop="moduleName">
                        <el-input v-model="addModuleForm.moduleName" auto-complete="off" placeholder="请输入模块名称"></el-input>
                    </el-form-item>
                    <el-form-item label="模块描述" prop="moduleContent">
                        <el-input v-model="addModuleForm.moduleContent" type="textarea" auto-complete="off" placeholder="请输入模块描述（选填）"></el-input>
                    </el-form-item>
                    <el-form-item label="背景图（尺寸640*64）" prop="bgImage">
                        <el-input v-model="addModuleForm.bgImage" auto-complete="off" placeholder="请输入图片链接（选填）"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="addModuleSubmit">提交</el-button>
                        <el-button @click="clearModuleFormData">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="modules" v-if="specialId">
            <div slot="header">
                <p class="title">已有模块</p>
            </div>
            <el-table class="module-list" :data="moduleList">
                <el-table-column prop="moduleId" label="模块ID" align='center'>
                </el-table-column>
                <el-table-column prop="moduleName" label="模块名称" align='center' width="240">
                </el-table-column>
                <el-table-column label="模块背景图" align='center' width="300">
                    <template scope="scope">
                        <img class="module-bg" v-if="scope.row.bgImage" :src="scope.row.bgImage" alt="模块背景图">
                        <p v-else>无背景图</p>
                        <!--<a style="margin-left: 10px" :href="scope.row.bgImage">{{scope.row.bgImage}}</a>-->
                    </template>
                </el-table-column>
                <el-table-column prop="isTop" label="置顶权重" align='center' width="100">
                </el-table-column>
                <el-table-column label="操作" align='center' min-width="220">
                    <template scope="scope">
                        <el-button-group>
                            <el-button size="small" type="info" @click="goTopModule(scope.row.moduleId)">置顶</el-button>
                            <el-button size="small" type="danger" @click="deleteModule(scope.row.moduleId)">删除</el-button>
                            <el-button size="small" type="success" @click="editModule(scope.row)">编辑</el-button>
                        </el-button-group>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!--编辑弹框-->
        <el-dialog title="编辑-模块" :visible.sync="dialogFormVisible">
            <el-form :model="editModuleForm" :rules="validateRules" ref="editModuleForm" label-width="100px" class="addSpecialForm">
                <el-form-item label="模块名称" prop="moduleName">
                    <el-input v-model="editModuleForm.moduleName" auto-complete="off" placeholder="请输入模块名称"></el-input>
                </el-form-item>
                <el-form-item label="模块描述" prop="moduleContent">
                    <el-input v-model="editModuleForm.moduleContent" type="textarea" auto-complete="off" placeholder="请输入模块描述（选填）"></el-input>
                </el-form-item>
                <el-form-item label="背景图（尺寸640*64）" prop="bgImage">
                    <el-input v-model="editModuleForm.bgImage" auto-complete="off" placeholder="请输入图片链接（选填）"></el-input>
                </el-form-item>
                <el-form-item class="el-form-item-btn-group">
                    <el-button type="primary" @click="editSubmit">提交</el-button>
                    <el-button @click="dialogFormVisible=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
import { mapGetters } from 'vuex';
export default {
    name: "specialAdd",
    data() {
        return {
            dialogFormVisible: false,
            specialList: null,
            moduleList: null,
            specialId: "",
            validateRules: {
                moduleName: [
                    { required: true, message: '请填写模块名称', trigger: 'change' }
                ]
            },
            addModuleForm: {
                moduleName: "",
                moduleContent: "",
                bgImage: ""
            },
            editModuleForm: {
                moduleName: "",
                moduleContent: "",
                bgImage: ""
            },
        };
    },
    mounted() {
        this._init();
    },
    methods: {
        _confirmMessage(message, success = () => { }, cancel = () => { }) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(success).catch(cancel);
        },
        //获取市场专题列表
        _getSpecialList() {
            this.$http.get(CONFIG.HOST + '/superSpecial/list?t=' + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.specialList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //获取专题对应的模块列表
        getModuleList() {
            if (this.specialId <= 0) {
                this.$notify.error({
                    message: '【营销平台】specialId=' + this.specialId + '的专题不存在'
                });
                return;
            }
            this.$http.get(CONFIG.HOST + '/superSpecialModule/list/' + this.specialId + "?t=" + TOOL.getCurrentTime()).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.moduleList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        _init() {
            this._getSpecialList();
        },
        //下拉选择专题
        selectSpecial() {
            this.getModuleList();
        },
        //添加模块
        addModuleSubmit() {
            let flag = true;
            this.$refs.addModuleForm.validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            if (this.specialId <= 0) {
                this.$notify.error({
                    message: '【营销平台】specialId=' + this.specialId + '的专题不存在'
                });
                return;
            }
            this.addModuleForm.projectId = this.specialId;
            this.$http.post(CONFIG.HOST + '/superSpecialModule/add', this.addModuleForm).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '添加模块成功'
                    });
                    this.getModuleList();
                    this.clearModuleFormData();
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //删除模块
        deleteModule(moduleId) {
            this._confirmMessage('是否确定删除moduleId=' + moduleId + '的模块？', () => {
                if (moduleId <= 0) {
                    this.$notify.error({
                        message: '【营销平台】moduleId=' + moduleId + '的模块不存在'
                    });
                    return;
                }
                this.$http.delete(CONFIG.HOST + '/superSpecialModule/delete/' + moduleId).then((response) => {
                    let result = response.body;
                    if (result && result.status === 1) {
                        this.$notify.success({
                            message: '删除模块成功'
                        });
                        this.getModuleList();
                        this.clearModuleFormData();
                    } else {
                        this.$notify.error({
                            message: result.message
                        });
                    }
                }, (response) => {
                    console.log(response);
                });
            });
        },
        //置顶模块
        goTopModule(moduleId) {
            if (moduleId <= 0) {
                this.$notify.error({
                    message: '【营销平台】moduleId=' + moduleId + '的模块不存在'
                });
                return;
            }
            this.$http.put(CONFIG.HOST + '/superSpecialModule/goTop', { moduleId: moduleId }).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '模块置顶成功'
                    });
                    this.getModuleList();
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //编辑模块
        editModule(row) {
            this.dialogFormVisible = true;
            Object.assign(this.editModuleForm, row);
        },
        //编辑模块提交
        editSubmit() {
            let flag = true;
            this.$refs.editModuleForm.validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.put(CONFIG.HOST + '/superSpecialModule/update', this.editModuleForm).then((response) => {
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '模块更新成功'
                    });
                    this.getModuleList();
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            }, (response) => {
                console.log(response);
            });
        },
        //重置模块
        clearModuleFormData() {
            this.$refs.addModuleForm.resetFields();
        },
    }
};
</script>
<style lang="less">
.module-manage {
    width: 98%;
    margin: 0 auto;
    overflow-y: auto;
    .bread-nav {
        margin: 20px 0;
    }
    .special-head {
        margin: 20px;
        .title {
            text-align: left;
            font-size: 16px;
        }
        .special-select {
            text-align: left;
            span {
                font-size: 14px;
                font-weight: bolder;
                margin: 0 8px 0 34px;
            }
        }
    }
    .add-module {
        margin: 20px;
        .title {
            text-align: left;
            font-size: 16px;
        }
        .module-add-box {
            text-align: left;
            label {
                font-weight: bolder;
            }
        }
    }
    .modules {
        margin: 20px;
        .title {
            text-align: left;
            font-size: 16px;
        }
        .module-bg {
            margin: 5px 10px 0 10px;
            height: 26px;
            width: auto;
        }
    }
    .el-form-item-btn-group {
        .el-form-item__content {
            margin-left: 0!important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// Module.vue?5ad80ab2